/* eslint-disable */
<template>
    <section class="pedidos-section">
        <div class="container">
            <div class="section-title">
              <h4>{{ $t('home.title') }}</h4>
            </div>
            <div class="row">
              <div v-if="this.rs" class="col-md-4 index-option">
                <div class="box-pedido">
                  <router-link :to="route + 'registro-sanitario'">
                    <img :src="require('@/assets/img/pedidos1.png')" alt="pedidos1">
                    <h3>Registros Sanitarios</h3>
                  </router-link>
                </div>
              </div>
              <div v-if="this.tdc" class="col-md-4 index-option">
                <div class="box-pedido">
                  <router-link :to="route + 'tdc'">
                    <img :src="require('@/assets/img/pedidos3.png')" alt="pedidos3">
                    <h3>{{ $t('home.tdc') }}</h3>
                  </router-link>
                </div>
              </div>
              <div v-if="this.pricing" class="col-md-4 index-option">
                <div class="box-pedido">
                  <router-link :to="route + 'pricing-home'">
                    <img :src="require('@/assets/img/pricehistory.png')" alt="pricing">
                    <h3>{{ $t('home.pricing_title') }}</h3>
                  </router-link>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import {route} from "@/enviroment"
import axios from "axios";
import {TDC_ROLES} from "@/router";
import {PRICING_ROLES} from "@/router";

export default {
  name: "HomePage",
  props: {},
  data() {
    return {
      route: route,
      rs: false,
      tdc: false,
      pricing: false,
      vendor: false,
      pricing_admin: false,
    }
  },
  async created() {
    await this.getUserRole();
  },
  methods: {
    getUserRole() {
      const profile = sessionStorage.getItem('mccain_service_user_profile');
      if (profile) {
        const data = JSON.parse(profile);
        this.rs = !!data.Admin_RS || !!data.User_RS;
        this.tdc = data.tdcprofile && TDC_ROLES.includes(data.tdcprofile.toString().toLowerCase());
        this.pricing = data.Princing_profile && PRICING_ROLES.includes(data.Princing_profile);
        this.vendor = data.Princing_profile === PRICING_ROLES[0];
        this.pricing_admin = data.Princing_profile === PRICING_ROLES[3] || data.Princing_profile === PRICING_ROLES[4];
      }
    },
    logout() {
      axios.get(
          '/auth/logout'
      ).then(() => {
        window.localStorage.clear();
        location.href = route + "login";
      });
    },
  },
}
</script>

<style scoped>
  .box-pedido{
    height: 220px;
  }
  .box-pedido img{
    max-width: 100px;
  }
</style>